import React, { useCallback } from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import './style.css';
import { useSelector } from "react-redux"
import parsePhoneNumber from 'libphonenumber-js';
import { debounce } from 'lodash';
import { getActiveCountryCode } from "../../../Utils/Utility";

function MobileInput({ phone, handlePhone, handleValid }) {

    const debounceFn = useCallback(debounce(handleDebounceFn, 1000), []);
    const countryList = useSelector(state => state.getCountriesList.countries);
    const activeCountriesListCodes = getActiveCountryCode(countryList)

    function handleDebounceFn(value) {
        if (handleValid)
            handleValid(value); // calling parent function to set valid ph no
    }

    function handleValidation(valid) {
        debounceFn(valid);
    }

    function checkValidPhone(value, country) {
        value = value.slice(country.dialCode.length);
        const parsedNumber = parsePhoneNumber(value, country.iso2.toUpperCase());
        let valid = true;
        const isZero = value.length < 2;
        if (!isZero) {
            valid = parsedNumber?.isValid();
        }

        handleValidation(isZero ? false : valid);

        if (!valid && !isZero) {
            return 'Invalid phone: ' + value + ', ' + country.name;
        } else {

            return true;
        }
    }

    return (
        <React.Fragment>
            <PhoneInput
                isValid={checkValidPhone}
                country={'us'}
                onlyCountries={activeCountriesListCodes}
                value={phone}
                inputClass="form-control"
                placeholder={"MOBILE number"}
                countryCodeEditable={false}
                onChange={phone => handlePhone(phone)}
                containerClass={"form-group"}
            />
        </React.Fragment>
    );
}

export default MobileInput;